import inv from './inv-config'

const search = { ...inv.search }
search.inputs = search.inputs.slice()
search.inputs[0] = {
  type: 'InputSelect',
  title: 'Type',
  span: 6,
  options: 'getters/search/invPageType',
  getter: 'state/search/orderType',
  setter: 'commit/search/setOrderType',
  defaultValue: 2
}

const edit = { ...inv.edit }
edit.inputs = edit.inputs.slice()
edit.inputs[4] = {
  type: 'InputDatePicker',
  title: 'Pickup Date',
  span: 6,
  getter: 'state/edit/deliveryDate',
  setter: 'commit/edit/setDeliveryDate',
  width: 200
}

const draft = { ...inv.draft }
draft.inputs = draft.inputs.slice()
draft.inputs[19] = {
  type: 'InputSelect',
  title: 'Shipping type',
  span: 6,
  options: 'state/shipTypes',
  getter: 'state/edit/shipType',
  setter: 'commit/edit/setShipType',
  defaultValue: 4
}
draft.inputs[7] = {
  type: 'InputShow',
  title: 'Pickup Date',
  span: 6,
  getter: 'state/edit/deliveryDate',
  trans: 'getters/dateFormatAu',
  labelClass: 'detail-text-strong'
}

const approve = { ...inv.approve }
approve.inputs = approve.inputs.slice()
approve.inputs[7] = {
  type: 'InputShow',
  title: 'Pickup Date',
  span: 6,
  getter: 'state/edit/deliveryDate',
  trans: 'getters/dateFormatAu',
  labelClass: 'detail-text-strong'
}

export default {
  search,
  edit,
  draft,
  approve
}
